const WSMS_PROFILE_ID = "wsms_device_dashboard";

const normalize = (value) => String(value || "").trim().toLowerCase();

const hasWSMSToken = (value) => {
  const text = normalize(value);
  if (!text) return false;

  return ["wsms", "jalsense", "water supply", "water monitoring"].some((token) =>
    text.includes(token),
  );
};

export const resolveDeviceDashboardProfile = ({ device, deviceType } = {}) => {
  const explicitProfile = normalize(
    device?.device_type?.dashboard_profile ||
      deviceType?.config?.dashboard_profile ||
      deviceType?.dashboard_profile,
  );

  if (explicitProfile === WSMS_PROFILE_ID || explicitProfile === "wsms") {
    return WSMS_PROFILE_ID;
  }

  if (
    hasWSMSToken(device?.device_type?.name) ||
    hasWSMSToken(deviceType?.name) ||
    hasWSMSToken(device?.device_category) ||
    hasWSMSToken(deviceType?.category)
  ) {
    return WSMS_PROFILE_ID;
  }

  return "default_device_dashboard";
};

export const resolveDeviceOperationalRoute = ({ device, deviceType } = {}) => {
  const deviceId = device?.id;
  if (!deviceId) return "/device_onboarding";

  const profileId = resolveDeviceDashboardProfile({ device, deviceType });
  if (profileId === WSMS_PROFILE_ID) {
    return `/devices/${deviceId}/wsms`;
  }

  return `/devices/${deviceId}`;
};
